<template>
  <div class="checkDetail">
    <div class="checkDetail-top">
        <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
        <div>提现</div>
        <div></div>
    </div>
    <!-- 选择转出的钱包电子账户 -->
    <div class="idCrardForm">
       <van-form @submit="next">
         <div class="cardFormtChoice">
           <div class="choice-card">选择转出的钱包电子账户</div>
           <div class="choice-card2">选择钱包电子账户</div>
         </div>  
         <van-field
          :label="myAccount.text"
          readonly
        />
        <!-- 选择收款到账银行卡 -->
        <!-- <div class="card-form"> -->
          <div class="cardFormtChoice">
           <div class="choice-card">选择收款到账银行卡</div>
           <div class="choice-card2">绑定银行卡，即可激活平安银行电子账户用于交易</div>
         </div>  
         <van-field
          :label="curBankCard.text"
          placeholder="切换其他银行卡 >"
          readonly
          @click="onIdCardClick"
        />
        <van-popup v-model="idCardShow" round position="bottom">
         <van-picker 
          show-toolbar
          v-model="curBankCard.bankNo"
          :columns="bindCardDetail"   
          @cancel="idCardShow = false"
          @confirm="onIdCardConfirm"
          />
        </van-popup>
        <!-- </div> -->

        <!-- 提现金额 -->
        <div class="withdraw">
          <div class="check-withdraw">提现金额</div>
          <div class="check-money">
            <div class="money-type">￥</div>
            <div class="money-num">
              <van-field
              v-model="formData.amount"
              @input="onInputAmount"
              />  
            </div>
          </div>    
        </div>
       </van-form>
       <div class="check-line"></div>
    </div>

    <div class="check-point">
      <div class="point-moneyNo">当前余额：<span class="moneyNo">{{totalAmount}}</span>，本次单笔提现最多可提现<span>{{totalAmount}}</span>元</div>
      <div>*电子账户活动期间暂免提现手续费</div>
    </div>
    <div class="check-tixian">
      <div class="tixian" @click="onWithDraw">提现</div>
    </div>

    <!-- 提现弹框 -->
    <van-overlay :show="overlayShow">
      <div class="card-bind-wrapper" @click.stop>
        <div class="card-bind-block">
          <div class="bind-block-title">提现验证码</div>
          <div class="bind-block-detail">
            <div class="bind-block-detail-send">
              请注意查收{{mobile}}短信验证码
            </div>
          </div>
          <div class="bind-field-code">
            <van-field
              v-model="formData.smsCode"
              input-align="left"
              clearable
              center
              placeholder="请输入短信验证码"
              class="bink-field-input-back"
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  @click="sendCode"
                  v-show="codeShow"
                  >获取验证码</van-button
                >
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  :disabled="disCode"
                  @click="sendCode"
                  v-show="!codeShow"
                  >{{ count }}s</van-button
                >
              </template>
            </van-field>
            </div>

          <div class="bind-modify-submit">
            <div class="bind-modify" @click="backModify">取消</div>
            <div class="bind-modif-rightline"></div>
            <div class="bind-submit" @click="onSubmit">确定</div>
          </div>
        </div>
      </div>
    </van-overlay>

  </div>
  
  
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      formData:{
        otpOrderNo: "",
        businessNo: "",
        amount:"",
        smsCode: "",
        cardId:""
      },
      totalAmount:"",
      overlayShow:false,
      count: "",
      codeShow: true,
      disCode: false,
      timer: null,
      idCardShow:false,
      bindCardDetail:[], //银行卡列表
      curBankCard: {}, // 当前选中的银行卡
      myAccount: {},
      mobile: "",

    }
  },
  mounted(){
    this.myWalletDedail()
  },
  methods:{
    onIdCardClick(){
      this.idCardShow=true;
    },
    onIdCardConfirm(data){
      this.curBankCard = data;
      this.idCardShow=false;
    },
    myWalletDedail(){
      http.post(config.myWallet).then(({code,data})=>{
        data.bindCardDetail.forEach(item => {
          item.text = `${item.bankName}(${item.bankNo.slice(-4)})` 
          item.value = item.bankNo
        })
        this.bindCardDetail = data.bindCardDetail; // 银行卡列表
        this.curBankCard = data.bindCardDetail[0]
        
        data.myAccount.text = `${data.myAccount.bankShort}(${data.myAccount.bankAccount.slice(-4)})` 
        this.myAccount = data.myAccount

        this.mobile=data.mobile;
        this.totalAmount=data.totalAmount;
        this.bankImg=`https://bpo-dev.oss-cn-beijing.aliyuncs.com/client/bank_logo/${data.bindCardDetail[0].bankCode}.png`
      })
    },
    timerFun() {
      // 倒计时
      this.disCode = true;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    goBack(){
      this.$router.go(-1);
    },
    onInputAmount(value) { // 用户输入金额 TODO校验
      this.amountCheck(value)
    },
    amountCheck(value) {
      if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        this.$toast.fail('请输入数字，最多两位小数');
        return false
      }
      if (value > this.totalAmount) {
        this.$toast.fail('提现金额不能大于当前余额');
        return false
      }
      return true
    },
    onWithDraw(){
      if(!this.amountCheck(this.formData.amount)) {
        return false;
      }
      if(this.formData.amount==0){
        this.$toast.fail('请输入大于0的金额');
        return false;
      }
      this.overlayShow=true;
    },
    onSubmit(){
      const {smsCode, otpOrderNo,businessNo, amount } = this.formData;
      const payload = {
        amount,
        cardId: this.curBankCard.cardId, // 绑定银行卡
        otpOrderNo, // 流水号
        businessNo, // 业务请求流水号
        smsCode, // 短信验证码
      }
      if(!payload.smsCode){
        this.$toast.fail("请先输入短信验证码")       
      }else{
        http.post(config.transferConfirm,payload).then(({code,data,message})=>{
        if(code===0){
          if(data.code===200){
            // this.$router.push({path:"/myWallet"})
            this.$router.push({path:"/withdrawStep",query:{amount:payload.amount}})
          }else{
            this.$toast.fail(data.message)
          }
        }else{
          this.$toast.fail(message)
        }
      })
      }
    },
    next(){

    },
    sendCode(){
      this.formData.cardId=this.curBankCard.cardId;
      http.post(config.transferSendSms,this.formData).then(({code,data,message})=>{
          if (code === 0) {
            if(data.code===200){
              this.formData.otpOrderNo = data.otpOrderNo;
              this.formData.businessNo = data.businessNo;
              this.timerFun();
            }else{
              this.$toast.fail(data.message)
            }
          }else{
            this.$toast.fail(message)
          }
      })

    },
    backModify(){
      this.overlayShow=false;
    }
  }
  
}
</script>
<style>
#app{
  background: #F8F8F8;
}
.checkDetail .van-field__value{
  display: flex;
  align-items: center;
}
.checkDetail .van-field__label{
  width: 300px;
}
.cardFormtChoice 

.checkDetail .money-num .van-cell{
  font-size: 66px;
}
.checkDetail .van-field__label{
  font-size: 30px;
}
.checkDetail .van-field__button{
  margin-left: 43px;
}
</style>
<style lang="less" scoped>
.checkDetail{
  .checkDetail-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding:20px;
    font-size: 35px;
    color: #222222;
    background: #ffffff;
    .jian{
      font-size: 35px;
    }
  }
  .idCrardForm{
    .cardFormtChoice{
      padding: 30px;
      text-align: left;
      background: #F8F8FA;
      .choice-card{
        color: #333333;
        font-size: 36px;
        font-weight: 500;
      }
      .choice-card2{
        font-size: 28px;
        color: #999999;
      }

    }
    .withdraw{
      background: #ffffff;
      margin-top: -15px;
      padding: 5px 0;
      .check-withdraw{
      margin-top: 30px;
      text-align: left;
      padding-left: 30px;
      font-size: 32px;
      color: #333333;
    }
    .check-money{
      display: flex;
      align-items: center;
      padding: 0 30px;
      .money-type{
        font-size: 66px;
      }
    }
    }
    .check-line{
      width: 100%;
      height: 1px;
      background: #ECECEC;
    }
  }
  .check-point{
    padding: 30px;
    text-align: left;
    color: #666666;
    .point-moneyNo{
      margin-bottom: 10px;
      .moneyNo{
        color: #ff0000;
    }
    }
  }
  .check-tixian{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 90px;
    .tixian{
    width: 90%;
    background: #0681FD;
    height: 90px;
    border-radius: 45px;
    line-height: 90px;
    text-align: center;
    color: #ffffff;
    font-size: 34px;
  }

  }
  .card-bind-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .card-bind-block {
    width: 90%;
    height: 448px;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
    box-sizing: border-box;
    .bind-block-title {
      font-size: 32px;
      color: #333333;
      margin-bottom: 20px;
      font-weight: 500;
    }
    .bind-block-detail {
      color: #666666;
      font-size: 28px;
      margin-bottom: 60px;
      .bink-block-detail-send {
      }
      .bink-block-detail-get {
      }
    }
    .bind-field-code {
      .bind-block-code {
        width: 180px;
        height: 74px;
        background: #4da5ff;
        border: none;
        border-radius: 45px;
        height: 90px;
        margin-right: -25px;
      }
      .bink-field-input-back {
        background: rgba(6, 129, 253, 0.04);
        border-radius: 45px;
        height: 90px;
      }
    }
    .bind-modif-rightline {
      height: 100px;
      width: 1px;
      background: #ececec;
    }
    .bind-modify-submit {
      width: 100%;
      height: 100px;
      border-top: 1px solid #ececec;
      font-size: 34px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 60px;
      .bind-submit {
        color: #0681fd;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/wallet/checkDetail/index.vue